'use client';
import Image from '@/types/Image';
import NextImage from 'next/image';
import LocaleLink from '@/components/LocaleLink';
import { useTranslations } from 'next-intl';

interface BlogCardProps {
	title: string;
	image: Image;
	description: string;
	href: string;
	locale: string;
	priority?: boolean;
}

const BlogCard = ({
	image,
	title,
	description,
	href,
	locale,
	priority = false,
}: BlogCardProps) => {
	const t = useTranslations('Common');
	const { src, alt } = image;
	return (
		<article className="relative flex h-full cursor-pointer flex-col gap-2 pb-3 duration-200 hover:-translate-y-2">
			<NextImage
				src={src}
				alt={alt}
				width={360}
				height={200}
				priority={priority}
				className="h-36 w-full rounded object-cover object-center md:h-40"
			/>
			<h3 className="font-bold">{title}</h3>
			<p className="flex-1">{description}</p>
			<LocaleLink
				href={href}
				locale={locale}
				className="text-blue-deep after:absolute after:inset-0">
				{t('readArticle')}
			</LocaleLink>
		</article>
	);
};
export default BlogCard;
